import { useParticipationSuspense } from '../api/get-participation';
import { FlyoutRow, FlyoutSection } from '@/shared/components/flyout';
import { formatMoney } from '@/utils/shared/Utils';
import { Award } from 'lucide-react';
import { Switch } from '@/shared/components/ui/switch';
import { useUpdateParticipationCollected } from '../api/update-participation-collected';
import { useAuth } from '@/hooks/auth/use-auth';
import { MembershipRole } from '@/types/api/membership';

export function ParticipationPanel({ userId, saleId }: { userId: string; saleId: string }) {
  const { context } = useAuth();
  const { data: participation } = useParticipationSuspense({
    userId,
    saleId,
    params: { include: ['products', 'user'] },
  });
  const updateCollected = useUpdateParticipationCollected();

  return (
    <>
      <div className="text-gray-800 dark:text-gray-100 font-semibold text-center mb-1">Säljare</div>
      <div className="max-w-sm mx-auto lg:max-w-none flex flex-col gap-6">
        {/* Main */}
        <div className="drop-shadow-md mt-16 text-center">
          <FlyoutSection>
            <div className="size-24 inline-flex p-4 bg-white border-ring rounded-full -mt-16">
              <Award className="text-primary size-16" />
            </div>
            <h3 className="text-base font-medium text-gray-800 dark:text-gray-100 mb-3">{participation.user!.name}</h3>

            <FlyoutRow label="Hämtat produkterna">
              {context?.membershipRoles.includes(MembershipRole.Leader) && (
                <Switch
                  checked={participation.collected}
                  onCheckedChange={(collected) => updateCollected.mutate({ data: { collected }, saleId, userId })}
                />
              )}
            </FlyoutRow>
            <FlyoutRow label="Nått målet">
              <Switch disabled checked={participation.targetReached} />
            </FlyoutRow>
          </FlyoutSection>
        </div>

        {/* Sales */}
        <FlyoutSection label="Försäljning">
          <FlyoutRow label="Produkter">
            {participation.unitCount} / {participation.unitCountTarget} st
          </FlyoutRow>
          <FlyoutRow label="Förtjänst">{formatMoney(participation.profit)}</FlyoutRow>
          <FlyoutRow label="Beställningar">{participation.orderCount} st</FlyoutRow>
        </FlyoutSection>

        {/* Items */}
        <FlyoutSection label="Produkter">
          {participation.items
            .filter((item) => item.quantity)
            .map((item) => (
              <FlyoutRow label={item.product!.name}>{`${item.quantity} st`}</FlyoutRow>
            ))}
        </FlyoutSection>
      </div>
    </>
  );
}
